import PropTypes from 'prop-types'
import React,{ useState} from 'react'
import { useDrop } from '../contexts/DropContext'
import {FaMouse} from "react-icons/fa"
import 'react-tooltip/dist/react-tooltip.css'
import {Tooltip as ReactTooltip} from "react-tooltip"


const MouseButton = ({experimentID, sessionID, color, loadMouse }) => {
  const [buttonState, changeButtonState] = useState(true)
  const buttonClick = () => {
    changeButtonState(experimentID)    
    loadMouse(experimentID, sessionID)
  }
 
  return (
    <button
      onClick={buttonClick}
      style={{
        backgroundColor: color,
        width: '40px',
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
      className='btn'
      id = {sessionID + "note"}
      data-tooltip-content = "View Mouse Info"
    >
      <div style={{ justifyContent: "center" }}>
      <FaMouse/>
      <ReactTooltip anchorId={sessionID + 'note'}/>
      </div>
    </button>
  )
}


MouseButton.defaultProps = {
  color: 'steelblue',
  sessionID: 837360280,
}

MouseButton.propTypes = { 
  sessionID: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
}

export default MouseButton